module.exports = __webpack_public_path__ + "img/jardimmx_02.f8527d64.jpg";